import React, { Component } from "react";

class SliderHandleButton extends Component {
  render() {
    return (
      <button {...this.props} type="button">
        {this.props["aria-valuenow"]}
      </button>
    );
  }
}

export default SliderHandleButton;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/slider/SliderHandleButton.js